module.exports = __webpack_public_path__ + "static/media/queen_club.0a41e4d5.png";